// TODO: Use property.helpers.js instead of TenantsSpacesString -Adam
// TODO: Rename this -Adam
const TenantsSpacesStrings = {
    purpose: {
        RESTAURANT: 'Restaurant',
        RETAIL: 'Traditional Retail',
        OTHER: 'Other Service',
        DISTRIBUTION: 'Distribution',
    },
    density: {
        SUBURBAN: 'Suburban',
        URBAN: 'Urban',
        RURAL: 'Rural',
    },
    size: {
        _0TO1: '0 - 999 SF',
        _1TO5: '1,000 - 4,999 SF',
        _5TO10: '5,000 - 9,999 SF',
        _GT10: '10,000+ SF',
    },
    typeOfCenter: {
        MALL: 'Mall',
        POWER: 'Power',
        SPECIALTY: 'Specialty/Lifestyle',
        COMMUNITY: 'Community/Neighborhood',
        STRIP: 'Strip Center/Convenient Center',
        OUTLET: 'Outlet Center',
        MIXED: 'Mixed-Use',
    },
    typeOfFacility: {
        FREESTANDING: 'Free Standing',
        INLINE: 'In-Line',
        ENDCAP: 'End Cap',
    },
};

const ProductsStrings = {
    areYou: {
        LOOKING: 'Looking for Product(s) and Service(s)',
        PROVIDING: 'Providing Product(s) and Service(s)',
    },
    productTypes: {
        THIRDPARTYLEASING: '3rd Party Specialty Leasing',
        DESIGNCONSTRUCTION: 'Design & Construction',
        PROJECTMANAGEMENT: 'Development & Project Management',
        LENDING: 'Financial & Lending',
        INSURANCE: 'Insurance',
        LEGAL: 'Legal Services',
        MANAGEMENT: 'Management Consulting',
        MARKETANALYSIS: 'Market Analysis / Research',
        MARKETING: 'Marketing & Publications',
        OPERATIONS: 'Operations / Maintenence',
        ASSETMANAGEMENT: 'Property / Asset Management',
        REALESTATE: 'Real Estate',
        SPECIALTYRETAIL: 'Specialty Retail / Anscillary Income',
        TECH: 'Techonology & Software',
        VENDOR: 'Vendor',
        VISUAL: 'Visual Merchandising',
        WHOLESALE: 'Wholesaler / Distributor / Licensor',
    },
};

const ConnectionsStrings = {
    connectionType: {
        AC: 'Academic',
        AQ: 'Acquisitions',
        AA: 'Admin/Executive Assistant',
        AD: 'Architect/Design',
        CN: 'Construction',
        CM: 'Corporate Staff Management',
        DV: 'Development',
        EC: 'Economic Development',
        EM: 'EDP/MIS/IT',
        AE: 'Engineer',
        ES: 'Environmental Sustainability',
        FA: 'Finance/Accounting',
        HR: 'Human resources',
        IN: 'Insurance/Risk Management',
        IB: 'Investment Banking',
        LR: 'Leasing/Real Estate',
        LG: 'Legal',
        MN: 'Maintenence',
        MK: 'Marketing/Advertising/Public Relations',
        OP: 'Operations/Management',
        OT: 'Other',
        PC: 'Planning Consultancy',
        PB: 'Public/Municipal Government',
        RS: 'Research',
        SC: 'Security',
        SL: 'Specialty Leasing',
    },
};

const ConnectionsSlugStrings = {
    connectionType: {
        AA: 'ADMIN/EXECUTIVE ASSISTANT',
        AC: 'ACADEMIC',
        AD: 'ARCHITECT/DESIGN',
        AE: 'ENGINEER',
        AQ: 'ACQUISITIONS',
        CM: 'CORPORATE STAFF MANAGEMENT',
        CN: 'CONSTRUCTION',
        DV: 'DEVELOPMENT',
        EC: 'ECONOMIC DEVELOPMENT',
        EM: 'EDP/MIS/IT',
        ES: 'ENVIRONMENTAL SUSTAINABILITY',
        FA: 'FINANCE/ACCOUNTING',
        HR: 'HUMAN RESOURCES',
        IB: 'INVESTMENT BANKING',
        IN: 'INSURANCE/RISK MANAGEMENT',
        LG: 'LEGAL',
        LR: 'LEASING/REAL ESTATE',
        MK: 'MARKETING/ADVERTISING/PUBL REL',
        MN: 'MAINTENANCE',
        OP: 'OPERATIONS/MANAGEMENT',
        OT: 'OTHER',
        PB: 'PUBLIC/MUNICIPAL GOVERNMENT',
        PC: 'PLANNING CONSULTANCY',
        RS: 'RESEARCH',
        SC: 'SECURITY',
        SL: 'SPECIALTY LEASING',
    },
};

const toCheckboxOrRadioOptions = stringsObject => {
    const values = Object.keys(stringsObject);
    const labels = Object.values(stringsObject);

    return values.map((value, index) => ({
        value,
        label: labels[index],
    }));
};

export { TenantsSpacesStrings, ProductsStrings, ConnectionsStrings, ConnectionsSlugStrings, toCheckboxOrRadioOptions };
